import React from 'react';

import PropTypes from 'prop-types';

import Group from '@asteria/component-core/group';

import { cn } from '@asteria/utils-funcs/classes';

import CurrencyChip from './chip';

/**
 * @typedef { import('../../../basic/types').Props } Props
 * @typedef { import('../../../basic/types').ChildrenProps } ChildrenProps
 */

/** @type { React.FC<ChildrenProps & { data: unknown[], type: string, onChangeType: (type: string) => void }> } */
const Selector = React.memo(function Selector(props) {
	const { query, data, type, onChangeType } = props;

	if (!query.isLoading && data.length < 2) {
		return null;
	}

	return (
		<Group
			className={cn(
				'asteria-component__card-section',
				'asteria--type-switcher',
				'asteria-component__chip-group',
			)}
			direction="horizontal"
			horizontalAlign="left"
		>
			{query.isLoading
				? Array.from({ length: 3 }).map((_, index) => (
						<CurrencyChip key={index} loading />
				  ))
				: data.map(({ code }) => (
						<CurrencyChip
							key={code}
							currency={code}
							onClick={() => {
								onChangeType(code);
							}}
							active={type === code}
						/>
				  ))}
		</Group>
	);
});

Selector.propTypes = {
	query: PropTypes.object,
	data: PropTypes.arrayOf(PropTypes.object),
	type: PropTypes.string,
	onChangeType: PropTypes.func,
};

export default Selector;
